import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PageHeader } from '@/components/layout';
import { Spinner } from '@/components/ui';
import { ApiErrorDisplay } from '@/components/features/error';
import { AssetLibrary } from '@/components/features/merchants/assets/asset-library';
import { useMerchantAssets } from '@/hooks/use-merchant-assets';

/**
 * Asset-Bibliothek pro Merchant (Contract v2.14, Spec 514/332 Inc 1).
 * Echte Daten über den BFF (`/admin/merchant-assets`); `usedBy` wird BFF-seitig
 * aus den Service-`…AssetId`-Feldern abgeleitet. Platform-only (Route-Gate).
 */
export function MerchantAssetsPage() {
  const { t } = useTranslation('merchant-assets');
  const { id } = useParams<{ id: string }>();
  const { data: assets, isLoading, error, refetch } = useMerchantAssets(id);

  return (
    <div>
      <PageHeader title={t('page.title')} description={t('page.description', { merchant: id ?? '' })} />

      {isLoading ? (
        <div className="flex items-center justify-center py-12">
          <Spinner size="lg" />
        </div>
      ) : error ? (
        <ApiErrorDisplay error={error} onRetry={() => refetch()} />
      ) : (
        <AssetLibrary merchantId={id ?? ''} assets={assets ?? []} />
      )}
    </div>
  );
}
